import {
  getDefaultStatisticItem,
  getTeamLabelByNumber,
  getTeamNumberByLabel
} from '../../utils/utils'

let previousActiveSide = null
let previousPlayTime = null
let isPeriodActive = false
let lastPenaltyKicks = 0
let lastPossession = 0
let lastScoreNames = []

export default {
  statisticScheme: {
    'TIMEOUT': getDefaultStatisticItem('statistic.hockey.timeouts'),
    'ACE': getDefaultStatisticItem('statistic.tennis.ace'),
    'SERVE_SCORES': getDefaultStatisticItem('statistics.scoresOnServe'),
    'RECIEVE_SCORES': getDefaultStatisticItem('statistics.scoresOnReceive'),
    'POINT_SERVE_ERROR': getDefaultStatisticItem(),
    'POINT_BLOCK': getDefaultStatisticItem(),
    'MAX_GOALS_IN_A_ROW': getDefaultStatisticItem('statistic.scoreMax', { maxValueInSumStatistic: true })
  },
  statisticEvents: {
    'TIMEOUT': 'TIMEOUT',
    'ACE': 'POINT_ACE',
    'POINT_SERVE_ERROR': 'POINT_SERVE_ERROR',
    'POINT_BLOCK': 'POINT_BLOCK'
  },
  statisticOrder: [
    'SERVE_SCORES',
    'RECIEVE_SCORES',
    'TIMEOUT',
    'MAX_GOALS_IN_A_ROW',
    'ACE',
    'POINT_SERVE_ERROR',
    'POINT_BLOCK'
  ],
  statisticFunction (event) {
    const { EventCode } = event

    if (EventCode === 'HEARTBEAT') return

    processMaxGoalsInARow.bind(this)(event)
    processServeScores.bind(this)(event)
    if (EventCode === 'CANCEL') updateStatisticsForCancel.bind(this)(event)
    adjustStatistic.bind(this)(event)
  }
}

function adjustStatistic (event) {
  const { getCurrentPeriod, updateStatistic } = this
  const { EventCode, extra } = event
  const { count_1, count_2, period } = extra

  if ([
    'ADJUST_POINT_SERVE_ERROR',
    'ADJUST_POINT_BLOCK',
    'ADJUST_POINT_ACE'
  ].includes(EventCode)) {
    const properties = {
      'ADJUST_POINT_SERVE_ERROR': 'POINT_SERVE_ERROR',
      'ADJUST_POINT_BLOCK': 'POINT_BLOCK',
      'ADJUST_POINT_ACE': 'ACE'
    }

    const newStatistic = {
      statisticType: 'defaultStatistic',
      property: properties[EventCode],
      period: period || getCurrentPeriod
    }

    newStatistic.value = count_1
    newStatistic.key = 'home'
    updateStatistic(newStatistic)

    newStatistic.value = count_2
    newStatistic.key = 'away'
    updateStatistic(newStatistic)
  }
}

function updateStatisticsForCancel (event) {
  const { RelatedEventNumber } = event
  const { getEventCache, getMatchPeriods, getCurrentPeriod } = this
  const relatedEvent = getEventCache[RelatedEventNumber]
  const { EventCode, TeamNumber, GamePeriod } = relatedEvent
  const { events } = getMatchPeriods[getCurrentPeriod]
  const eventTeam = getTeamLabelByNumber(TeamNumber)

  if (EventCode === 'POINT') {
    const lastScoreName = lastScoreNames.pop()
    if (lastScoreName === 'SERVE_SCORES') {
      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: 'SERVE_SCORES',
        period: GamePeriod,
        team: eventTeam,
        type: 'decrement'
      })
    } else if (lastScoreName === 'RECIEVE_SCORES') {
      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: 'RECIEVE_SCORES',
        period: GamePeriod,
        team: eventTeam,
        type: 'decrement'
      })
    }
  }

  if (['POINT', 'POINT_ACE', 'POINT_BLOCK'].includes(EventCode)) {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'MAX_GOALS_IN_A_ROW',
      period: GamePeriod,
      team: eventTeam,
      value: maxPointSeries(events,  TeamNumber)
    })
  }
}

function processServeScores (event) {
  const { getActiveSide } = this
  const { TeamNumber, EventCode, GamePeriod } = event
  const eventTeam = getTeamLabelByNumber(TeamNumber)

  if (EventCode !== 'POINT') {
    return
  }

  if (eventTeam === getActiveSide) {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'SERVE_SCORES',
      period: GamePeriod,
      team: eventTeam,
      type: 'increment'
    })
    lastScoreNames.push('SERVE_SCORES')

    return
  }

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'RECIEVE_SCORES',
    period: GamePeriod,
    team: eventTeam,
    type: 'increment'
  })
  lastScoreNames.push('RECIEVE_SCORES')
}

function processMaxGoalsInARow (event) {
  const { getMatchPeriods, getCurrentPeriod } = this
  const { TeamNumber, EventCode, GamePeriod } = event
  const { events } = getMatchPeriods[getCurrentPeriod]

  if (!GamePeriod) return

  const teamLabel = getTeamLabelByNumber(TeamNumber)

  if (EventCode !== 'POINT') return

  const newEvent = {
    EventCode: event.EventCode,
    teamNumber: event.TeamNumber
  }

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'MAX_GOALS_IN_A_ROW',
    period: GamePeriod,
    team: teamLabel,
    value: maxPointSeries([...events, newEvent], TeamNumber)
  })
}

function maxPointSeries (currentPeriodEvents, team) {
  const events = currentPeriodEvents.filter(event => event.EventCode === 'POINT' && !event.canceled)

  if (events.length === 0) return 0

  let seriesLength = 0
  let maxSeriesLength = 0

  for (let i = 0; i < events.length; i++) {
    if (events[i].teamNumber === team) {
      seriesLength += 1
      if (seriesLength > maxSeriesLength) {
        maxSeriesLength = seriesLength
      }
    } else {
      seriesLength = 0
    }
  }
  return maxSeriesLength
}
